<template >
    <div class="landing-template">

    <div class="bg-layer"></div>
    <nav>
        <div class="container-landing">
            <div class="navbar">
                <div class="brand-link">
                    <a href="" class="navbar-brand">
                        <img src="../assets/images/pairboard-logo.svg" alt="" class="nav-logo">
                    </a>
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a href="#features-start" class="nav-link">Features</a>
                        </li>
                        <li class="nav-item" >
                            <a href="" class="nav-link" style="visibility: hidden;">Features</a>
                        </li>
                        <li class="nav-item"  style="visibility: hidden;">
                            <a href="" class="nav-link">Pricing</a>
                        </li>
                    </ul>
                </div>
                <div class="btn-desktop">
                    <div class="flex items-center gap-x-7">
                        <a href="/login" class="nav-link">Login</a>
                        <a href="/login" class="btn-start">Start for free</a>
                    </div>
                </div>
                <div class="hamburger" aria-label="Toggle navigation">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <!-- Hamburger Menu -->
            <!-- Background Layer -->
            <div class="mobile-menu-layer"></div>
            <!-- Mobile Menu -->
            <div class="mobile-menu">
                <button class="close-menu" aria-label="Close menu">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M12.5 3.5L3.5 12.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M12.5 12.5L3.5 3.5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </button>
                <ul>
                    <li><a href="#" class="nav-link">Home</a></li>
                    <li><a href="" class="nav-link" style="visibility: hidden;">Product</a></li>
                    <li><a href="" class="nav-link" style="visibility: hidden;">Pricing</a></li>
                    <li><a href="/login" class="nav-link">Login</a></li>
                    <li><a href="/login" class="btn-start">Start for free</a></li>
                </ul>
            </div>
        </div>
    </nav>

    <!-- ----------------------------------- Nav ----------------------------------------------- -->


    <!-- ----------------------------------- Header ----------------------------------------------- -->
    <header class="mt--80">
        <div class="container-landing">
            <div class="text-center">
                <h2>
                    Simplify Goals with P<span class="highlight-ai-2">ai</span>rboard.
                </h2>
                <h1 class="mb-4">
                    The <span class="highlight-ai-1">AI-Powered</span> To-Do Revolution.
                </h1>
                <p class="fs--20">Tell us your goals—AI takes care of the rest.</p>
                <div class="relative mt-96">
                    <img src="../assets/images/header-main.svg" alt="" class="header-img">
                    <div class="img-bg-shadow"></div>
                </div>
            </div>
        </div>
    </header>
    <!-- ----------------------------------- Header ----------------------------------------------- -->


    <!-- ----------------------------------- Section ALL IN ONE PAGE ----------------------------------------------- -->
    <section class="mt-96">
        <div id="features-start" class="container-landing">
            <div class="text-center">
                <h2 class="fw-500 mb-4">Everything You Need, <span class="highlight-ai-3 text-shadow">All in One
                        Place.</span></h2>
                <p class="fs--20 mb--2px">Simplify tasks, connections, and files—everything </p>
                <p class="fs--20 fw-500 highlight-ai-3 text-shadow">organized effortlessly with Pairboard.</p>
            </div>
            <!-- ---------------manage task --------------- -->
            <div class="mt-96">
                <div class="flex flex-row-col items-center justify-between gap-x-105 gap-y-sm-7">
                    <div class="flex-1 order-sm-1">
                        <img src="../assets/images/manage-task.svg" alt="" class="w-full h-auto md--none">
                        <!-- -------for laptop----  -->
                        <div class="sm--hidden">
                            <img src="../assets/images/confirmation-popup.png" alt="" class="manage-task-img h-auto">
                            <div class="flex relative">
                                <div class="task-manages-lines">
                                <span class="task-manage-line">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="250" viewBox="0 0 26 250" fill="none">
                                        <path d="M1.45874 0.212891L1.4587 236.928C1.4587 243.331 6.6496 248.522 13.0529 248.522L25.6133 248.522" stroke="url(#paint0_linear_341_24589)" stroke-opacity="0.16" stroke-width="1.15942"/>
                                        <defs>
                                        <linearGradient class="task-manager-3" id="paint0_linear_341_24589" x1="13.611" y1="124.367" x2="-35.5829" y2="224.356" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                            <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </span>
                                <span class="task-manage-line-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="230" viewBox="0 0 35 230" fill="none">
                                        <path d="M1.32349 0.212891L1.32345 217.604C1.32345 224.007 6.51435 229.198 12.9176 229.198L34.1737 229.198" stroke="url(#paint0_linear_341_24588)" stroke-opacity="0.4" stroke-width="1.15942"/>
                                        <defs>
                                        <linearGradient class="task-manager-2" id="paint0_linear_341_24588" x1="17.8506" y1="114.706" x2="-16.5302" y2="217.763" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                            <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </span>
                                <span class="task-manage-line-3">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="47" height="210" viewBox="0 0 47 210" fill="none">
                                        <path d="M1.15454 0.212891L1.1545 197.314C1.1545 203.718 6.3454 208.908 12.7487 208.908L46.5652 208.908" stroke="url(#paint0_linear_341_24587)" stroke-width="1.15942"/>
                                        <defs>
                                        <linearGradient class="task-manager-3" id="paint0_linear_341_24587" x1="14.0009" y1="104.561" x2="2.10209" y2="204.123" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                            <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                        </linearGradient>
                                        </defs>
                                    </svg>
                                </span>
                            </div>
                                <img src="../assets/images/manage-task-22.png" alt="" class="manage-task-img ml--12 h-auto">
                            </div>
                        </div>
                        <!-- -------for laptop----  -->
                    </div>
                    <div class="flex-1 flex-end">
                        <h3 class="text-sm-center text-dark-rgba max-w-464 fw-500">Manage tasks <span
                                class="text-dark-6b">manually or let</span> <span
                                class="highlight-ai-3 fw-600">Pairboard's AI</span> organize and complete <span
                                class="text-dark-6b">them for you.</span></h3>
                    </div>
                </div>
            </div>
            <!-- ---------------manage task --------------- -->
            <!-- ---------------pairboard analyzes--------------- -->
            <div class="mt-96">
                <div class="flex flex-row-col items-center justify-between gap-x-105 gap-y-sm-7">
                    <div class="flex-1">
                        <h3 class="text-sm-center text-dark-rgba max-w-464 fw-500">Pairboard analyzes <span
                                class="text-dark-6b">your inbox and</span> <span class="highlight-ai-3 fw-600">converts
                                emails into organized tasks,</span> <span class="text-dark-6b">saving you</span> time
                            and effort.</h3>
                    </div>
                    <div class="flex-1">
                        <img src="../assets/images/pairboard-analysis.svg" alt="" class="w-full h-auto md--none">
                        <div class="relative sm--hidden">
                            <img src="../assets/images/analyzes-img-1.svg" alt="" class="w-full h-auto ">
                                <div class="flex relative ml--18">
                                    <span class="analyzes-animate-line">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="113" viewBox="0 0 27 113" fill="none">
                                            <path d="M0.566772 0.749512L0.566747 103.282C0.566745 108.375 4.69501 112.503 9.78748 112.503L26.2743 112.503" stroke="url(#paint0_linear_341_24666)" stroke-width="0.922073"/>
                                            <defs>
                                              <linearGradient class="task-manager-2" id="paint0_linear_341_24666" x1="13.5004" y1="56.6262" x2="2.35417" y2="110.2" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                                <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                              </linearGradient>
                                            </defs>
                                          </svg>
                                    </span>
                                    <div class="relative mt--14"> 
                                            <img src="../assets/images/analyzes-img-22.svg" alt="" class="w-full h-auto gradient-border"> 
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- ---------------pairboard analyzes--------------- -->
        </div>
    </section>
    <!-- ----------------------------------- Section ALL IN ONE PAGE ----------------------------------------------- -->


    <!-- ----------------------------------- Section AI-driven task management ----------------------------------------------- -->
    <section class="mt-112">
        <div class="container-landing">
            <div class="text-center">
                <h3 class="max-w-914 mx-auto text-dark-6b">Link Pairboard to tools like <span
                        class="text-dark-a0">Google, Microsoft, Jira, and Slack</span> for smarter <span
                        class="highlight-ai-3">AI-driven task management.</span></h3>
                <img src="../assets/images/task-management.svg" alt="" class="w-full h-auto mt--48 md--none">
                <!-- -----------------------------------  --------------------------------------------------------------------------------- -->

                <div class="max-w-1118 mx-auto sm--hidden pt--48">
                    <!-- ----------------------FIRST LOGO LINE-------------- -->
                    <div class="first-logo-flex relative">
                        <div class="logo-space">
                            <span style="visibility: hidden;" class="x-logo">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.2382" y="0.991011" width="77.2989" height="77.2989" rx="12.2225"
                                        stroke="white" stroke-opacity="0.04" stroke-width="1.98202" />
                                    <g clip-path="url(#clip0_341_24742)">
                                        <g clip-path="url(#clip1_341_24742)">
                                            <mask id="mask0_341_24742" style="mask-type:luminance"
                                                maskUnits="userSpaceOnUse" x="18" y="18" width="46" height="46">
                                                <path d="M18.6517 18.4048H63.9551V63.7082H18.6517V18.4048Z"
                                                    fill="white" />
                                            </mask>
                                            <g mask="url(#mask0_341_24742)">
                                                <g opacity="0.8">
                                                    <path
                                                        d="M53.514 21.2363H60.0274L45.7993 38.026L62.5393 60.8768H49.4337L39.1615 47.0207L27.4211 60.8768H20.9017L36.1187 42.9124L20.0674 21.2395H33.5067L42.7777 33.902L53.514 21.2363ZM51.2236 56.8527H54.8337L31.5348 25.051H27.6638L51.2236 56.8527Z"
                                                        fill="white" />
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_341_24742">
                                            <rect width="35.3933" height="35.3933" fill="white"
                                                transform="translate(22.8988 22.6519)" />
                                        </clipPath>
                                        <clipPath id="clip1_341_24742">
                                            <rect width="45.3034" height="45.3034" fill="white"
                                                transform="translate(18.6517 18.4048)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            <img src="../assets/images/logo/discord.png" alt="" class="img-border">
                            <!-- <span class="discord-logo cursor-pointer">
                                <svg width="80" height="80" viewBox="0 0 80 80" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.31682" y="0.991011" width="77.2989" height="77.2989" rx="12.2225"
                                        stroke="white" stroke-opacity="0.04" stroke-width="1.98202" />
                                    <g clip-path="url(#clip0_341_24686)">
                                        <g clip-path="url(#clip1_341_24686)">
                                            <path
                                                d="M55.6909 24.1877C52.7199 22.7906 49.5767 21.7979 46.3446 21.2358C45.942 21.9674 45.4716 22.9513 45.1472 23.734C41.6624 23.2073 38.2096 23.2073 34.7889 23.734C34.4647 22.9514 33.9837 21.9674 33.5774 21.2358C30.342 21.7981 27.1962 22.7934 24.2238 24.195C18.3089 33.1783 16.7054 41.9382 17.507 50.5742C21.4302 53.5186 25.2322 55.3073 28.97 56.4777C29.8991 55.1939 30.7202 53.8346 31.4251 52.4139C30.083 51.9004 28.7892 51.2676 27.5591 50.523C27.8828 50.2818 28.1989 50.0305 28.5069 49.7694C35.9611 53.2735 44.0605 53.2735 51.4258 49.7694C51.7352 50.0287 52.0512 50.28 52.3735 50.523C51.1414 51.2696 49.8452 51.9037 48.5004 52.4177C49.2093 53.8441 50.029 55.2047 50.9554 56.4813C54.6969 55.311 58.5023 53.5223 62.4255 50.5742C63.3663 40.563 60.8187 31.8835 55.6909 24.1877ZM32.4407 45.2632C30.203 45.2632 28.3678 43.1637 28.3678 40.607C28.3678 38.0503 30.1639 35.9472 32.4407 35.9472C34.7176 35.9472 36.5527 38.0466 36.5136 40.607C36.5171 43.1637 34.7177 45.2632 32.4407 45.2632ZM47.4919 45.2632C45.2541 45.2632 43.4192 43.1637 43.4192 40.607C43.4192 38.0503 45.215 35.9472 47.4919 35.9472C49.7689 35.9472 51.6038 38.0466 51.5647 40.607C51.5647 43.1637 49.7689 45.2632 47.4919 45.2632Z"
                                                fill="#5865F2" />
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_341_24686">
                                            <rect width="45.3034" height="45.3034" fill="white"
                                                transform="translate(17.3147 16.9888)" />
                                        </clipPath>
                                        <clipPath id="clip1_341_24686">
                                            <rect width="45.3034" height="35.3933" fill="white"
                                                transform="translate(17.3147 21.2358)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span> -->
                        </div>
                        <!-- ----------------------LINES-------------- -->
                        <div class="absolute-center-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="88" height="91" viewBox="0 0 88 91" fill="none">
                                <path d="M1.46069 90.2471V18.0448C1.46069 8.6622 9.06682 1.05606 18.4495 1.05606H87.8202" stroke="url(#paint0_linear_341_24774)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu" id="paint0_linear_341_24774" x1="44.9087" y1="45.6516" x2="42.7091" y2="1.15153" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </div>
                         
                        <!-- ----------------------LINES-------------- -->
                         
                        <span class="absolute-center-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="88" height="91" viewBox="0 0 88 91" fill="none">
                                <path d="M86.9663 90.2471V18.0448C86.9663 8.6622 79.3602 1.05606 69.9775 1.05606H0.606759" stroke="url(#paint0_linear_341_24775)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu" id="paint0_linear_341_24775" x1="43.5183" y1="45.6516" x2="45.7179" y2="1.15153" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <!-- ----------------------LINES-------------- -->
                        <div class="logo-space">
                            <span class="xoom-logo">
                                <svg width="81" height="80" viewBox="0 0 81 80" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.81126" y="0.991011" width="77.2989" height="77.2989" rx="12.2225"
                                        stroke="white" stroke-opacity="0.04" stroke-width="1.98202" />
                                    <g clip-path="url(#clip0_341_24698)">
                                        <path
                                            d="M40.4603 62.2921C52.9711 62.2921 63.1124 52.1499 63.1124 39.64C63.1124 27.1301 52.9711 16.9888 40.4603 16.9888C27.9495 16.9888 17.809 27.1301 17.809 39.64C17.809 52.1499 27.9504 62.2921 40.4603 62.2921Z"
                                            fill="#2196F3" />
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M31.1013 46.1145H46.0826V35.1291C46.0826 33.474 44.7414 32.1328 43.0864 32.1328H28.105V43.1182C28.105 44.7733 29.4463 46.1145 31.1013 46.1145ZM48.0792 42.1204L54.0717 46.1145V32.1328L48.0801 36.1278L48.0792 42.1204Z"
                                            fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_341_24698">
                                            <rect width="45.3034" height="45.3034" fill="white"
                                                transform="translate(17.809 16.9888)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                            <span class="linkedin-logo">
                                <svg style="visibility: hidden;" width="81" height="80" viewBox="0 0 81 80" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <rect x="1.88988" y="0.991011" width="77.2989" height="77.2989" rx="12.2225"
                                        stroke="white" stroke-opacity="0.04" stroke-width="1.98202" />
                                    <g clip-path="url(#clip0_341_24702)">
                                        <path
                                            d="M58.9438 18.0505H22.1349C21.2997 18.042 20.4953 18.3651 19.8981 18.949C19.3009 19.5329 18.9597 20.3299 18.9495 21.1651V58.1227C18.9616 58.9566 19.3036 59.7518 19.9005 60.3342C20.4975 60.9165 21.3009 61.2387 22.1349 61.2302H58.9438C59.7791 61.2369 60.583 60.9126 61.1798 60.3283C61.7767 59.744 62.118 58.9473 62.1292 58.1121V21.1544C62.1143 20.3217 61.7714 19.5286 61.1749 18.9473C60.5784 18.3661 59.7767 18.0438 58.9438 18.0505Z"
                                            fill="#0076B2" />
                                        <path
                                            d="M25.3415 34.2357H31.7512V54.8594H25.3415V34.2357ZM28.5481 23.9717C29.2833 23.9717 30.002 24.1897 30.6132 24.5982C31.2244 25.0067 31.7007 25.5874 31.9819 26.2666C32.2631 26.9459 32.3364 27.6933 32.1928 28.4143C32.0491 29.1353 31.6948 29.7974 31.1747 30.317C30.6546 30.8366 29.9921 31.1903 29.271 31.3333C28.5499 31.4763 27.8025 31.4022 27.1235 31.1204C26.4445 30.8385 25.8644 30.3617 25.4564 29.7501C25.0485 29.1385 24.8311 28.4196 24.8318 27.6844C24.8328 26.6994 25.2247 25.7551 25.9216 25.0589C26.6184 24.3627 27.5631 23.9717 28.5481 23.9717ZM35.7719 34.2357H41.9162V37.0672H42.0011C42.8576 35.4462 44.9458 33.7367 48.064 33.7367C54.5551 33.7225 55.7585 37.9945 55.7585 43.5335V54.8594H49.3488V44.8254C49.3488 42.4363 49.3063 39.3607 46.0183 39.3607C42.7302 39.3607 42.171 41.9656 42.171 44.6697V54.8594H35.7719V34.2357Z"
                                            fill="white" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_341_24702">
                                            <rect width="45.3034" height="45.3034" fill="white"
                                                transform="translate(17.8876 16.9888)" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                        </div>
                        
                    </div>
                    <!-- ----------------------FIRST LOGO LINE-------------- -->
                    <!-- ----------------------SECOND LOGO LINE-------------- -->
                    <div class="second-logo-flex">
                        <img src="../assets/images/logo/instagram.svg" alt="" class="img-border">
                        <!-- -----start-------  -->
                        <span class="animated-svg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="284" height="3" viewBox="0 0 284 3" fill="none">
                                <path d="M283.91 1.71924L233.317 1.71924L0.764101 1.71924" stroke="url(#paint0_linear_341_24776)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu" id="paint0_linear_341_24776" x1="234.36" y1="1.71924" x2="117.274" y2="6.95379" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <!-- -----end-------  -->
                        <img src="../assets/images/logo/pb.svg" alt="" class="pb-logo">
                        <!-- -----start-------  -->
                        <span class="">
                            <svg xmlns="http://www.w3.org/2000/svg" width="284" height="3" viewBox="0 0 284 3" fill="none">
                                <path d="M0.516846 1.71924L51.1103 1.71924L283.663 1.71926" stroke="url(#paint0_linear_341_24777)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24777" x1="50.0674" y1="1.71924" x2="167.153" y2="-3.5153" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <!-- -------end-----  -->
                            <img src="../assets/images/logo/slack.png" alt="" class="img-border w--80 clickup">
                    </div>
                    <!-- ----------------------SECOND LOGO LINE-------------- -->
                    <!-- ----------------------THIRD LOGO LINE-------------- -->
                    <div class="third-logo-flex relative">
                        <div class="flex-25">
                            <img style="visibility: hidden;" src="../assets/images/logo/whatsapp.png" alt="" class="img-border w--80">
                            <img src="../assets/images/logo/telegram.png" alt="" class="img-border w--80">
                        </div>
                        <span class="absolute-third-right">
                            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="100" viewBox="0 0 70 100" fill="none">
                                <path d="M1.28088 0.854004V81.5506C1.28088 90.9333 8.88701 98.5394 18.2696 98.5394H69.2359" stroke="url(#paint0_linear_341_24764)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24764" x1="35.4695" y1="49.6967" x2="32.124" y2="98.3238" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <span class="absolute-third-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="69" height="100" viewBox="0 0 69 100" fill="none">
                                <path d="M67.9775 0.854004V81.5506C67.9775 90.9333 60.3714 98.5394 50.9888 98.5394H0.0224827" stroke="url(#paint0_linear_341_24769)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24769" x1="33.789" y1="49.6967" x2="37.1344" y2="98.3238" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <div class="flex-25">
                            <img src="../assets/images/logo/microsoft-teams.png" alt="" class="img-border w--80">
                            <img style="visibility: hidden;" src="../assets/images/logo/slack.png" alt="" class="img-border w--80 clickup">
                        </div>
                    </div>
                    <!-- ----------------------THIRD LOGO LINE-------------- -->
                    <!-- ----------------------FOURTH LOGO LINE-------------- -->
                    <div class="fourth-logo-flex relative">
                        <img src="../assets/images/logo/facebook.png" alt="" class="img-border w--80">
                        <span class="absolute-long-line">
                            <svg xmlns="http://www.w3.org/2000/svg" width="332" height="178" viewBox="0 0 332 178" fill="none">
                                <path d="M330.472 0.854004V159.416C330.472 168.798 322.866 176.405 313.483 176.405H0.606708" stroke="url(#paint0_linear_341_24773)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24773" x1="165.539" y1="39.4751" x2="167.933" y2="176.363" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <span class="absolute-long-line-left">
                            <svg xmlns="http://www.w3.org/2000/svg" width="330" height="178" viewBox="0 0 330 178" fill="none">
                                <path d="M0.955078 0.854004V159.416C0.955078 168.798 8.56121 176.405 17.9438 176.405H329.404" stroke="url(#paint0_linear_341_24772)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24772" x1="165.18" y1="38.3048" x2="162.745" y2="176.362" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>
                        </span>
                        <img src="../assets/images/logo/gsuite.png" alt="" class="img-border w--80 gsuite" style="height: auto;">
                        
                    </div>
                    <!-- ----------------------FOURTH LOGO LINE-------------- -->
                    <!-- ----------------------FIFTH LOGO LINE-------------- -->
                    <div class="fifth-logo-flex relative">
                        <img src="../assets/images/logo/x-logo.png" alt="" class="img-border w--80 clickup">
                        <span class="absolute-clickup-line">
                            <svg xmlns="http://www.w3.org/2000/svg" width="477" height="246" viewBox="0 0 477 246" fill="none">
                                <path d="M475.966 0.854004V227.371C475.966 236.753 468.36 244.36 458.978 244.36H0.280928" stroke="url(#paint0_linear_341_24771)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24771" x1="238.124" y1="17.1349" x2="241.945" y2="244.295" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>                             
                        </span>
                        <span class="absolute-trnasfer-line">
                            <svg xmlns="http://www.w3.org/2000/svg" width="478" height="246" viewBox="0 0 478 246" fill="none">
                                <path d="M1.46069 0.854004V227.371C1.46069 236.754 9.06682 244.36 18.4495 244.36H477.146" stroke="url(#paint0_linear_341_24770)" stroke-width="1.69888"/>
                                <defs>
                                  <linearGradient class="transform-gpu-2" id="paint0_linear_341_24770" x1="239.303" y1="26.3371" x2="235.622" y2="244.297" gradientUnits="userSpaceOnUse">
                                    <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                    <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                  </linearGradient>
                                </defs>
                              </svg>                            
                        </span>
                        <img src="../assets/images/logo/transfer.png" alt="" class="img-border w--80 clickup">

                    </div>
                    <!-- ----------------------FIFTH LOGO LINE-------------- -->
                </div>

                <!-- -----------------------------------  ---------------------------------------------------------------------------------- -->

            </div>
        </div>
    </section>
    <!-- ----------------------------------- Section AI-driven task management ----------------------------------------------- -->


    <!-- ----------------------------------- Section Google Vertex AI ----------------------------------------------- -->
    <section class="mt-88">
        <div class="container-landing">
            <div class="flex flex-row-col items-center justify-between gap-x-105 gap-y-sm-7">
                <div class="flex-1">
                    <h3 class="text-sm-center text-dark-6b fw-500 max-sm-300">Your <span class="text-dark-rgba">data
                            stays secure</span> with <span class="text-dark-rgba">Pairboard,</span> powered by <span
                            class="highlight-ai-3 fw-600">Google Vertex AI.</span></h3>
                </div>
                <div class="flex-none order-sm-1">
                    <img src="../assets/images/google-vertex-2.png" alt="" class="w-full h-auto md--none">
                    <div class="relative sm--hidden layer">
                        <!-- <div class="first-layer">
                            <div class="second-layer">
                                <div class="third-layer">
                                    <div class="relative">
                                        <img src="../assets/images/bg-circle.png" alt="" class="circle-gradient">
                                        <img src="../assets/images/vertex-logo.svg" alt="" class="vertex-logo">
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div>
                            <div class="third-layer">
                                <div class="relative">
                                    <img src="../assets/images/bg-circle.png" alt="" class="circle-gradient">
                                    <img src="../assets/images/vertex-logo.svg" alt="" class="vertex-logo">
                                </div>
                            </div>
                            <div class="circles">
                                <div class="circle1"></div>
                                <div class="circle2"></div>
                                <div class="circle3"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ----------------------------------- Section Google Vertex AI ----------------------------------------------- -->


    <!-- ----------------------------------- Section achieve goals ----------------------------------------------- -->
    <section class="mt-96">
        <div class="container-landing">
            <div class="flex flex-row-col items-center justify-between gap-x-105 gap-y-sm-7">
                <div class="flex-1 order-sm-1 ml--30">
                    <img src="../assets/images/achieve-golas.svg" alt="" class="w-full h-auto md--none" >
                    <div class="relative sm--hidden">
                        <div class="flex items-end">
                            <span class="achieve-svg-line">
                                <svg xmlns="http://www.w3.org/2000/svg" width="50" height="161" viewBox="0 0 50 161" fill="none">
                                    <path d="M27 160L10.2207 160C5.12822 160 0.999961 155.872 0.999962 150.779L0.999998 10.22C0.999999 5.12794 5.12793 1.00001 10.22 1.00001L49.5 1.00001" stroke="url(#paint0_linear_341_24893)" stroke-width="0.922073"/>
                                    <defs>
                                        <linearGradient class="task-manager-3" id="paint0_linear_341_24893" x1="14" y1="30.5" x2="-20.8006" y2="149.853" gradientUnits="userSpaceOnUse">
                                            <stop stop-color="#E0E0E0" stop-opacity="0.12"/>
                                        <stop offset="1" stop-color="#00F5A0" stop-opacity="0.64"/>
                                        </linearGradient>
                                    </defs>
                                </svg>
                            </span>
                            <img src="../assets/images/achieve-laptop.png" alt="" class="achieve-goal-img">
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <h3 class="text-sm-center text-dark-rgba fw-500 max-w-achive">Pairboard enables <span
                            class="text-dark-6b">your</span> team to <span class="highlight-ai-3">work together</span>
                        <span class="text-dark-6b">efficiently on</span> projects, <span class="text-dark-6b">share
                            insights, and</span> <span class="highlight-ai-3">achieve goals</span> <span
                            class="text-dark-6b">in harmony.</span>
                    </h3>
                </div>
            </div>
        </div>
    </section>
    <!-- ----------------------------------- Section achieve goals ----------------------------------------------- -->


    <!-- ----------------------------------- Section One Click Away. ----------------------------------------------- -->
    <section class="mt-136">
        <div class="container-landing">
            <div class="text-center max-w-960 mx-auto">
                <h2 class="fw-500 lh-normal mb-4">Your Goals Are <span class="highlight-ai-3">One Click Away.</span>
                </h2>
                <p class="fs--20 mb-32">Step into the future of productivity. Let <span
                        class="highlight-ai-3 fw-500">Pairboard</span> organize your life with the power of AI.</p>
                    <a href="/login" class="btn-free-trail">Start Now for Free
                    <span>
                        <svg class="right-icon" viewBox="0 0 23 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M2.16669 11.0001H20.8334M20.8334 11.0001L11.5 1.66675M20.8334 11.0001L11.5 20.3334"
                                stroke="#1A1A1A" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </span>
                </a>
            </div>
        </div>
    </section>
    <!-- ----------------------------------- Section One Click Away. ----------------------------------------------- -->


    <!-- ----------------------------------- Footer ----------------------------------------------- -->
    <footer class="mt-96">
        <div class="container-landing">
            <div class="max-footer">
                <div class="footer-content">
                    <img src="../assets/images/footer-logo.svg" alt="" class="nav-logo">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <a href="" class="nav-link">Home</a>
                        </li>
                        <li class="nav-item">
                            <a href="/login" class="nav-link">Login</a>
                        </li>
                        <li class="nav-item">
                            <a href="#features-start" class="nav-link">Features</a>
                        </li>
                    </ul>
                    <ul class="social-icons" style="visibility: hidden;">
                        <li>
                            <a href="" class="">
                                <svg width="12" height="10" viewBox="0 0 12 10" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M11.2071 1.9831C10.7881 2.16933 10.3458 2.28573 9.88023 2.35557C10.3458 2.07622 10.7183 1.63392 10.8812 1.0985C10.4389 1.35457 9.95006 1.5408 9.41465 1.6572C8.99562 1.2149 8.39037 0.935547 7.73856 0.935547C6.48149 0.935547 5.45721 1.95982 5.45721 3.21689C5.45721 3.40312 5.48049 3.56608 5.52705 3.72903C3.64145 3.63591 1.94208 2.72803 0.801411 1.33129C0.615178 1.68048 0.498783 2.05294 0.498783 2.47196C0.498783 3.26345 0.894527 3.96182 1.52306 4.38084C1.1506 4.35756 0.801411 4.26445 0.475504 4.10149V4.12477C0.475504 5.24216 1.26699 6.17333 2.31455 6.38284C2.12831 6.42939 1.9188 6.45267 1.70929 6.45267C1.56962 6.45267 1.40666 6.42939 1.26699 6.40612C1.56962 7.314 2.40766 7.98909 3.40866 7.98909C2.61717 8.59434 1.63945 8.96681 0.56862 8.96681C0.382388 8.96681 0.196156 8.96681 0.0332031 8.94353C1.05748 9.59534 2.24471 9.96781 3.54833 9.96781C7.76184 9.96781 10.0665 6.47595 10.0665 3.44968C10.0665 3.35656 10.0665 3.24017 10.0665 3.14705C10.5088 2.84443 10.9045 2.44868 11.2071 1.9831Z"
                                        fill="#E0E0E0" />
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a href="" class="">
                                <svg width="8" height="13" viewBox="0 0 8 13" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M2.70873 12.3038V6.75026H0.839844V4.58594H2.70873V2.98981C2.70873 1.13752 3.84005 0.128906 5.49242 0.128906C6.28392 0.128906 6.96418 0.187836 7.16243 0.214175V2.14993L6.01642 2.15045C5.11776 2.15045 4.94376 2.57748 4.94376 3.20411V4.58594H7.08697L6.80791 6.75026H4.94376V12.3038H2.70873Z"
                                        fill="#E0E0E0" />
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a href="" class="">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M7.00076 1.44721C8.80947 1.44721 9.02366 1.45398 9.73818 1.48656C10.1678 1.49182 10.5933 1.5707 10.9962 1.71979C11.2884 1.83248 11.5538 2.00511 11.7753 2.22656C11.9967 2.44802 12.1694 2.71339 12.282 3.00559C12.4311 3.40853 12.51 3.83406 12.5153 4.26366C12.5475 4.97817 12.5546 5.19237 12.5546 7.00108C12.5546 8.80979 12.5479 9.02398 12.5153 9.7385C12.51 10.1681 12.4311 10.5936 12.282 10.9966C12.1694 11.2888 11.9967 11.5541 11.7753 11.7756C11.5538 11.997 11.2884 12.1697 10.9962 12.2824C10.5933 12.4315 10.1678 12.5103 9.73818 12.5156C9.02398 12.5479 8.80979 12.5549 7.00076 12.5549C5.19172 12.5549 4.97753 12.5482 4.26334 12.5156C3.83373 12.5103 3.40821 12.4315 3.00527 12.2824C2.71307 12.1697 2.44769 11.997 2.22624 11.7756C2.00479 11.5541 1.83216 11.2888 1.71947 10.9966C1.57038 10.5936 1.4915 10.1681 1.48624 9.7385C1.45398 9.02398 1.44689 8.80979 1.44689 7.00108C1.44689 5.19237 1.45366 4.97817 1.48624 4.26366C1.4915 3.83406 1.57038 3.40853 1.71947 3.00559C1.83216 2.71339 2.00479 2.44802 2.22624 2.22656C2.44769 2.00511 2.71307 1.83248 3.00527 1.71979C3.40821 1.5707 3.83373 1.49182 4.26334 1.48656C4.97785 1.4543 5.19205 1.44721 7.00076 1.44721ZM7.00076 0.226562C5.16205 0.226562 4.93043 0.234304 4.20785 0.267208C3.64561 0.278391 3.08934 0.384847 2.56269 0.582046C2.11092 0.752261 1.70172 1.019 1.36366 1.36366C1.01869 1.70184 0.751722 2.11127 0.581401 2.56334C0.384201 3.08998 0.277746 3.64625 0.266563 4.2085C0.234304 4.93043 0.226562 5.16205 0.226562 7.00076C0.226562 8.83946 0.234304 9.07108 0.267208 9.79366C0.278391 10.3559 0.384847 10.9122 0.582046 11.4388C0.752178 11.8908 1.01892 12.3002 1.36366 12.6385C1.70191 12.9832 2.11133 13.25 2.56334 13.4201C3.08998 13.6173 3.64626 13.7238 4.2085 13.7349C4.93108 13.7672 5.16172 13.7756 7.0014 13.7756C8.84108 13.7756 9.07172 13.7679 9.7943 13.7349C10.3565 13.7238 10.9128 13.6173 11.4395 13.4201C11.8893 13.2457 12.2978 12.9794 12.6389 12.6381C12.98 12.2968 13.246 11.8882 13.4201 11.4382C13.6173 10.9115 13.7238 10.3553 13.735 9.79301C13.7672 9.07108 13.775 8.83946 13.775 7.00076C13.775 5.16205 13.7672 4.93043 13.7343 4.20785C13.7231 3.64561 13.6167 3.08934 13.4195 2.56269C13.2493 2.11068 12.9826 1.70126 12.6379 1.36301C12.2996 1.01828 11.8902 0.751533 11.4382 0.581401C10.9115 0.384201 10.3553 0.277746 9.79301 0.266563C9.07108 0.234304 8.83947 0.226562 7.00076 0.226562Z"
                                        fill="#E0E0E0" />
                                    <path
                                        d="M7.00215 3.52344C6.31413 3.52344 5.64155 3.72746 5.06948 4.10971C4.49741 4.49195 4.05154 5.03525 3.78824 5.6709C3.52494 6.30655 3.45605 7.00601 3.59028 7.68081C3.72451 8.35561 4.05582 8.97546 4.54233 9.46197C5.02884 9.94847 5.64868 10.2798 6.32349 10.414C6.99829 10.5482 7.69774 10.4794 8.33339 10.2161C8.96904 9.95276 9.51234 9.50689 9.89459 8.93481C10.2768 8.36274 10.4809 7.69017 10.4809 7.00215C10.4809 6.07954 10.1144 5.19471 9.46197 4.54233C8.80958 3.88994 7.92476 3.52344 7.00215 3.52344ZM7.00215 9.26021C6.55555 9.26021 6.11897 9.12778 5.74764 8.87966C5.3763 8.63154 5.08688 8.27888 4.91597 7.86627C4.74506 7.45366 4.70034 6.99964 4.78747 6.56162C4.8746 6.1236 5.08966 5.72125 5.40546 5.40545C5.72125 5.08966 6.1236 4.8746 6.56162 4.78747C6.99964 4.70034 7.45367 4.74506 7.86627 4.91597C8.27888 5.08687 8.63154 5.3763 8.87966 5.74763C9.12778 6.11897 9.26021 6.55554 9.26021 7.00215C9.26021 7.60102 9.02231 8.17537 8.59884 8.59884C8.17537 9.02231 7.60102 9.26021 7.00215 9.26021Z"
                                        fill="#E0E0E0" />
                                    <path
                                        d="M10.6176 4.19807C11.0665 4.19807 11.4305 3.83412 11.4305 3.38517C11.4305 2.93621 11.0665 2.57227 10.6176 2.57227C10.1686 2.57227 9.80469 2.93621 9.80469 3.38517C9.80469 3.83412 10.1686 4.19807 10.6176 4.19807Z"
                                        fill="#E0E0E0" />
                                </svg>
                            </a>
                        </li>
                        <li>
                            <a href="" class="">
                                <svg width="14" height="13" viewBox="0 0 14 13" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M6.6088 0.226562C3.01786 0.226562 0.128906 3.11552 0.128906 6.70646C0.128906 9.56841 1.99188 11.9984 4.55684 12.8624C4.88083 12.9164 4.98883 12.7274 4.98883 12.5384C4.98883 12.3764 4.98883 11.9714 4.98883 11.4314C3.17986 11.8364 2.80186 10.5674 2.80186 10.5674C2.50487 9.81141 2.07287 9.62241 2.07287 9.62241C1.47888 9.21742 2.12687 9.21742 2.12687 9.21742C2.77486 9.27142 3.12586 9.89241 3.12586 9.89241C3.69285 10.8914 4.63783 10.5944 5.01583 10.4324C5.06983 10.0004 5.23182 9.73041 5.42082 9.56841C3.98984 9.40642 2.47787 8.83942 2.47787 6.35546C2.47787 5.65347 2.72086 5.05948 3.15286 4.62749C3.09886 4.46549 2.85586 3.8175 3.20686 2.89952C3.20686 2.89952 3.74685 2.73752 4.98883 3.57451C5.50182 3.43951 6.06881 3.35851 6.6088 3.35851C7.14879 3.35851 7.71578 3.43951 8.22878 3.57451C9.47076 2.73752 10.0107 2.89952 10.0107 2.89952C10.3617 3.79051 10.1457 4.43849 10.0647 4.62749C10.4697 5.08648 10.7397 5.65347 10.7397 6.35546C10.7397 8.83942 9.22776 9.37942 7.76978 9.54141C8.01278 9.73041 8.20178 10.1354 8.20178 10.7294C8.20178 11.5934 8.20178 12.2954 8.20178 12.5114C8.20178 12.6734 8.30977 12.8894 8.66077 12.8354C11.2257 11.9984 13.0887 9.56841 13.0887 6.70646C13.0887 3.11552 10.1997 0.226562 6.6088 0.226562Z"
                                        fill="#E0E0E0" />
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="mt--48 border-top">
                    <p class="fs--14 pt-24">© 2025 Pairboard.com</p>
                </div>
            </div>
        </div>
    </footer>
    <!-- ----------------------------------- Footer ----------------------------------------------- -->
    <div class="h-326"></div>
    </div>

</template>

<script type="text/javascript">


document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nav-item .nav-link').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default anchor behavior
            const target = document.querySelector(this.getAttribute('href'));
            target.scrollIntoView({ behavior: 'smooth' });
        });
        });



    const hamburger = document.querySelector('.hamburger');
    const mobileMenu = document.querySelector('.mobile-menu');
    const closeMenu = document.querySelector('.close-menu');
    const mobileMenuLayer = document.querySelector('.mobile-menu-layer');
    const body = document.body;

    // Check if elements exist to prevent errors
    if (hamburger && mobileMenu && closeMenu && mobileMenuLayer) {
        // Open the menu
        hamburger.addEventListener('click', () => {
            mobileMenu.classList.add('active');
            mobileMenuLayer.classList.add('active');
            body.classList.add('no-scroll'); // Add class to prevent scrolling
        });

        // Close the menu
        closeMenu.addEventListener('click', () => {
            mobileMenu.classList.remove('active');
            mobileMenuLayer.classList.remove('active');
            body.classList.remove('no-scroll'); // Remove class to allow scrolling
        });

        mobileMenuLayer.addEventListener('click', () => {
            mobileMenu.classList.remove('active');
            mobileMenuLayer.classList.remove('active');
            body.classList.remove('no-scroll'); // Remove class to allow scrolling
        });
    }
});

</script>


<style scoped>
@import "@/assets/landing.css"; /* Import your CSS file */
</style>